import Rollbar from "rollbar";

window.Rollbar = Rollbar;

export const onClientEntry = (_args, options) => {
  if (process.env.NODE_ENV === "production" && options.accessToken != "") {
    window.rollbar = new Rollbar(options);
  }
};
